// NPM Imports
import React, { Fragment } from "react";

// Internal Imports
import { NumberInput } from "@revvsales/components";

export default class RevvGridPercentage extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      cellValue: 0,
      localUpdate: false,
      showComponent: false,
    };
  }

  componentDidMount() {
    const { row, field } = this.props;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    this.setState({ cellValue });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { row, field } = nextProps;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    if (!prevState.localUpdate && cellValue !== prevState.cellValue) {
      return { cellValue };
    }
    return null;
  }

  _onChange = value => {
    this.setState({ cellValue: value, localUpdate: true });
  };

  _onBlur = () => {
    if (this.state.cellValue || this.state.cellValue === 0) {
      this.props.onChange(parseFloat(this.state.cellValue));
      this.setState({ showComponent: false, localUpdate: false });
    } else {
      this.setState({ cellValue: 0, showComponent: false, localUpdate: false });
    }
  };

  _decideComponent = () => (
    <NumberInput
      autoFocus
      inputRef={this.textInput}
      isFloat
      limitTo={100}
      onBlur={this._onBlur}
      onChange={this._onChange}
      onKeyPress={event => {
        if (event.key === "Enter") {
          this._onBlur();
        }
      }}
      placeholder="Percentage"
      value={this.state.cellValue}
      data-test="rgpercentage-number-input"
    />
  );

  render() {
    const { field, readOnly, row } = this.props;
    const editable =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.editable;
    return (
      <Fragment>
        {this.state.showComponent && this._decideComponent()}
        {!this.state.showComponent && (
          <div
            className={`rs-cell ${editable && !readOnly ? "is-editable" : ""}`}
            onClick={() =>
              editable && !readOnly && this.setState({ showComponent: true })
            }
            onKeyPress={() => null}
            role="button"
            tabIndex="0">
            {`${(this.state.cellValue - 0).toFixed(2)}%`}
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Components/RG_Percentage.js